export const domIds = {
  welcome: 'welcome',
  expertise: 'expertise',
  projects: 'projects',
  customers: 'customers',
  contact_us: 'contact_us',
};
